import { useLocation } from 'react-router-dom';

export function useTableStorageKey(tableId?: string): string {
  const { pathname } = useLocation();

  return generateTableKey(pathname, tableId);
}

const STORAGE_PREFIX = 'table_layout';

export function generateTableKey(pathname: string, tableId?: string): string {
  const path = getRouteStorageKey(pathname);
  return `${STORAGE_PREFIX}:${path}:${tableId ?? 'default'}`;
}

export function getRouteStorageKey(pathname: string): string {
  return pathname
    .split('/')
    .filter((seg) => {
      if (!seg) return false;

      if (/^\d+$/.test(seg)) return false;

      return true;
    })
    .join(':');
}
